import DefaultTennisRules from "./rulesets/default";

const RuleSetLibrary = [DefaultTennisRules];

class RulesetLibrary {
    getRuleSetById(ruleSetId) {
        return RuleSetLibrary.find((rs) => rs.id === ruleSetId);
    }
}

export default new RulesetLibrary();
